import { HeadSectionProps } from 'components/HeadSection';
import { useGlobalData } from 'contexts';
import { SearchPage, SearchPageProps } from 'modules/search-page/desktop';
import { getServerSideProps as getSSP } from 'modules/search-page/shared';
import Head from 'next/head';
import { useRouter } from 'next/router';

const Page: React.FC<SearchPageProps> = ({ seoInfo, ...props }) => {
  const { baseDomain, canonicalDomain, schemaProductCollectionSellerInfo } =
    useGlobalData();
  const router = useRouter();
  const { query } = router;

  let canonical: string | undefined;
  if (seoInfo?.canonical) {
    if (canonicalDomain) {
      canonical = `${canonicalDomain}${seoInfo.canonical}`;
    } else if (baseDomain) {
      canonical = `${baseDomain}${seoInfo.canonical}`;
    }
  }

  const pageSeoInfo: HeadSectionProps | SearchPageProps['seoInfo'] = {
    ...seoInfo,
    metaTitle: seoInfo?.metaTitle || seoInfo?.siteTitle,
    canonical,
    description: seoInfo?.metaDescription
      ? seoInfo?.metaDescription
      : undefined,
    siteDescription: seoInfo?.siteDescription,
    siteTitle: seoInfo?.siteTitle,
    keywords: seoInfo?.metaKeywords,
  };

  const pageProps = {
    ...props,
    seoInfo: pageSeoInfo,
  };

  return (
    <>
      {!!schemaProductCollectionSellerInfo && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'ProductCollection',
                name: seoInfo?.siteTitle,
                url: `${baseDomain}/c/${query.slug}`,
                image:
                  seoInfo?.thumbnailUrl ||
                  (props.serverProducts?.length
                    ? props.serverProducts?.[0].imageUrl
                    : ''),
                description: seoInfo?.metaDescription,
                offers: {
                  '@type': 'AggregateOffer',
                  priceCurrency: 'VND',
                  lowPrice: props.filterPrice?.min,
                  highPrice: props.filterPrice?.max,
                  offerCount: props.serverPagination?.totalItems,
                  seller: schemaProductCollectionSellerInfo,
                },
              }),
            }}
          />
        </Head>
      )}
      <SearchPage {...(pageProps as SearchPageProps)} />
    </>
  );
};

export default Page;

export const getServerSideProps = getSSP;
